import { EEnvironment } from '~/entities';

export const isDevBuildMode = () =>
  import.meta.env.VITE_APP_MM_BUILD_MODE === EEnvironment.DEVELOPMENT;

export const isProdBuildMode = () =>
  import.meta.env.VITE_APP_MM_BUILD_MODE === EEnvironment.PRODUCTION;

export const isReleaseBuildMode = () =>
  import.meta.env.VITE_APP_MM_BUILD_MODE === EEnvironment.RELEASE;
